<template>
    
    <div class="puzzle-container" v-if="isMobile()">

        <Header />      

        <PuzzleCountdown 
            :isSuccess="isSuccess"
            :toStartTimer="toStartTimer"
        />
        
        <PuzzleBoard 
            :imageId="imageId"
        />

        <Footer />

        <PuzzleDialog 
            v-if="hasEnd && showDialog" 
            :isSuccess="isSuccess"
            :addRequest="addRequest"
            :num="num"
            :detail="detail"
            :openShareDialog="openShareDialog"
        />

        <PuzzlePreparationDialog 
            :imageId="imageId"
            v-if="showPDailog"
            :closePreparationDialog="closePreparationDialog"
        />

        <PuzzleShareDialog 
            v-if="showSDialog"
        />
    </div>

    <Warning v-else />
</template>

<script>

    import { 
        getCurrentInstance, 
        onMounted, 
        onUnmounted,
        reactive,
        toRefs 
    } from "vue";
    import { useRoute } from "vue-router";
    import jsonp from "jsonp";

    import PuzzleBoard from "@/components/puzzle-board";
    import PuzzleCountdown from "@/components/puzzle-countdown";
    import Header from "@/components/header";
    import Footer from "@/components/footer";
    import PuzzleDialog from "@/components/puzzle-dialog";
    import PuzzlePreparationDialog from "@/components/puzzle-preparation-dialog";
    import PuzzleShareDialog from "@/components/puzzle-share-dialog";
    import Warning from "@/components/warning";

    import HelperMixin from "@/mixins/helper";

    export default {
        name: "Puzzle",
        mixins: [ HelperMixin ],
        components: {
            PuzzleBoard,
            PuzzleCountdown,
            Footer,
            Header,
            PuzzleDialog,
            PuzzlePreparationDialog,
            PuzzleShareDialog,
            Warning
        },
        setup() {

            const _this = getCurrentInstance().appContext.config.globalProperties;
            const route = useRoute();

            const { id } = route.query;

            const state = reactive({
                imageId: id,
                isSuccess: false,
                hasEnd: false,
                num: 0,
                detail: null,
                toStartTimer: false,
                showPDailog: true,
                showDialog: true,
                showSDialog: false
            });

            const { EVENT, ENUM, REQUEST, KEY, OTHERS } = _this.$constants;

            const { END_OPERATION } = EVENT;

            const { detail1 } = OTHERS.imageArr.filter(image => image.groupId === id)[0].back;

            state.detail = detail1;

            onMounted(() => {

                addRequest();

                registerListeners();
            });

            onUnmounted(() => {
                _this.$bus.$off(END_OPERATION);
            });

            const registerListeners = () => {
                
                _this.$bus.$on(END_OPERATION, ({ type }) => {

                    const { SUCCESS } = ENUM.END_OPERATION;

                    /**
                     * type: 1 - 时间到， 2 - 顺利结束
                     */

                    if (!state.hasEnd) {
                        state.hasEnd = true;
                    }

                    switch(type) {
                        case SUCCESS:
                            state.isSuccess = true;
                    }
                });
            };

            const addRequest = () => {

                const id = KEY.HONGKONG;

                const url = `${REQUEST.ROOT}${REQUEST.ADD}?id=${id}`;

                jsonp(url, null, (_, data) => {
                    state.num = data[id];
                });
            };

            const closePreparationDialog = () => {

                state.showPDailog = false;
                state.toStartTimer = true;
            }

            const openShareDialog = () => {

                state.showSDialog = true;
                state.showDialog = false;
            }

            return {
                ...toRefs(state),
                addRequest,
                closePreparationDialog,
                openShareDialog
            }
        }
    };
</script>

<style lang="scss" scoped>

    @media screen and (min-height: 800px) {
        
        .puzzle-container {
            background: url(../assets/puzzle/bg.jpg) fixed no-repeat;
            background-size: auto 100%;
            background-position: 50% 50%;
            width: 100vw;
            height: 100vh;
            background-attachment: fixed;
        }

         .puzzle-container:before{
            content: "";
            position: fixed;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
            background-image: inherit;
            -webkit-background-size: cover!important;
            -o-background-size: cover;
            background-size: cover!important;
        }
    }

    @media screen and (max-height: 800px) {
        .puzzle-container {
            background: url(../assets/puzzle/bg.jpg) fixed no-repeat;
            background-size: cover;
            background-position: 50% 50%;
            width: 100vw;
            height: 100vh;
            background-attachment: fixed;
        }
    }
</style>